import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {message} from '@/utils/message.js';
import http from '@/request/axios.js'

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.$message = message;
Vue.prototype.$http = http;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
